import React, {useState} from "react";
import { PropsData } from "../../../context";
import { Modal, Text, Button, Selector, FileUpload, Link, Loader, Icon } from "@virkesborsen/ui-component-library";
import { ContentContainer } from "./utils/utils";
import {ErrorModal} from "../../../../../modals";
import { TailwindWrapper } from "../../../../TailwindWrapper/TailwindWrapper.jsx";

export const UploadPdfStep = ({ currentStepIndex, totalSteps, handleBack, handleNext, handleClose, arbonicsData, updateCo2Deal }) =>{
    
    const [fileError, setFileError] = useState('');
    const [successText, setSuccessText] = useState('');

    const [file,setFile] = useState(null);
    const [isLoading,setIsLoading] = useState(false);
    const [errorModal,setErrorModal] = useState(false);
    
    const handleFileUpload = (data)=> {
        if(data[0].valid){
            setFile(data[0].file)
            setSuccessText("Du har laddat upp en korrekt fil")
        }
    }

    async function readFileAsync(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            
            reader.readAsText(file);
        });
    }

    const validateFiles = async(data) => {
        if (data.file.type !== "application/pdf"){
            setFileError("Kindly upload a pdf file")
        }
        const fileText = await Promise.resolve(readFileAsync(data.file))
        setFileError("Detta verkar inte vara en PDF-fil")

        return fileText.indexOf("PDF") != -1
    }

    const skipStep = () => {
         handleNext({arbonicsData: {  }});
    }

    const handleSubmit = async() => {
        setIsLoading(true);
        let propandPdf = {...arbonicsData,"pdfFile":file}
        
        if (propandPdf?.pdfFile){
            var formData = new FormData()
            formData.append('file',propandPdf.pdfFile)
            formData.append('stage','pdf')
            formData.append('comments', 'Not sent, only finished step 3')

            const response = await updateCo2Deal(formData, false)
            handleNext({
                data:{
                    pdf_data:formData
                },
            });
            setIsLoading(false)
        }
        else{
            setIsLoading(false)
            setErrorModal(true)
        }
    }

     if (isLoading) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Text tw twIsolated variant="bodyMediumBaseRegular">
            Bearbetar din fil...
            </Text>
            <Loader />
          </div>
        );
      }
    return (
    <>
        <Modal.Content>
            <ContentContainer>
                <Text twIsolated variant="subheaderSmallMedium">Vald fastighet</Text>
                <Selector
                    name="selected-property"
                    variant="default"
                    onChange={() => { }}
                    options={[
                        {
                            label: arbonicsData.selectedProp.designation,
                            value: arbonicsData.selectedProp.ref
                        },
                    ]}
                />
                <Text tw twIsolated variant="subheaderSmallMedium">Ladda upp PDF-fil</Text>
                <Text tw twIsolated variant="bodySmallRegular" className="neutral-pebble">Du behöver ladda upp en PDF-fil för att vi ska kunna analysera din fastighetspotential. PDF filen får bara innehålla en fastighet för att analysen skall bli rätt.</Text>
                <FileUpload
                    accept=".pdf"
                    buttonText="Ladda upp pdf"
                    errorText={fileError}
                    successText={successText}
                    label="Filer som stöds: PDF"
                    onChange={handleFileUpload}
                    validation={validateFiles} />
            </ContentContainer>
        </Modal.Content>
        <Modal.Footer>
            <TailwindWrapper>
                <div className="flex justify-between w-full">
                    <Button
                        tw
                        variant="secondary"
                        onClick={skipStep}
                        disabled={''}
                    >Ingen digital skogsbruksplan</Button>
                    <Button
                        tw
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={successText == "Du har laddat upp en korrekt fil" ? false : true}
                    ><React.Fragment key=".0">
                        Nästa steg 
                        <Icon
                            color={successText == "Du har laddat upp en korrekt fil" ?"white-500":"charcoal-500"}
                            name="ArrowRightSimple"
                        />
                        </React.Fragment>
                    </Button>
                </div>
            </TailwindWrapper>
        </Modal.Footer>
        <ErrorModal show={errorModal} title={errorModal?.title} message={errorModal?.message} onToggle={() => setErrorModal(false)} />
    </>
    );
};